import styled from "styled-components";
import { colors } from "~/styles";

const { gray } = colors;

export const Container = styled.div`
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid ${gray._200};

  > div {
    font-size: 16px;
    font-weight: bold;
    color: ${gray._600};
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: ${gray._100};
  border-radius: 4px;
  border-left: 4px solid ${gray._400};

  > div {
    line-height: 1.6;
    margin-bottom: 6px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      font-weight: 600;
      color: ${gray._600};
    }
  }
`;

export const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${gray._300};

  h4,
  strong {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${gray._600};
  }

  svg {
    flex-shrink: 0;
  }
`;

export const ValueSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 18px;
  background: ${gray._100};
  border-radius: 4px;
  border-left: 4px solid ${gray._400};
  flex: 1;

  > div {
    line-height: 1.6;
    margin-bottom: 6px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      font-weight: 600;
      color: ${gray._600};
    }
  }
`;

export const ValueLabel = styled.span`
  font-weight: 600;
  color: ${gray._600};
  font-size: 14px;
`;

export const ValueAmount = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.primary._000};
  margin-top: 8px;
  line-height: 1.3;
`;

export const StatusSection = styled.div`
  border-radius: 4px;
  border-left: 4px solid
    ${({ color }) => {
      switch (color) {
        case "red":
          return "#D32F2F";
        case "orange":
          return "#C08400";
        case "blue":
          return "#008172";
        default:
          return gray._300;
      }
    }};
  background: ${gray._100};
  padding: 12px 15px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 15px;
`;

export const StatusTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: bold;
  color: ${colors.primary._000};
  display: flex;
  align-items: center;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
    background: ${({ color }) => {
      switch (color) {
        case "red":
          return "#D32F2F";
        case "orange":
          return "#C08400";
        case "blue":
          return "#008172";
        default:
          return gray._300;
      }
    }};
  }

  > svg {
    margin-left: 15px;
  }
`;

export const PartyItem = styled.div`
  display: flex;
  padding: 6px 0;
  border-bottom: 1px solid ${gray._200};
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }
`;

export const PartyName = styled.div`
  flex: 1;
  font-weight: 500;
  color: ${gray._600};
`;

export const PartyDocument = styled.div`
  flex: 1;
  color: ${gray._600};
`;

export const PartyType = styled.div`
  flex: 1;
  color: ${gray._600};
`;
